import { useCallback } from 'react';
import { useApiBase } from '../../base/api-base';

export class RedefinirSenhaProps {
    public constructor(
        public telefone: string = '',
        public email: string = '',
        public cpfCnpj: string = '',
    ) { }
}

export function usePostRedefinirSenha() {
    const { invocarApi, ...outrasPropriedades } = useApiBase();

    const postRedefinirSenha = useCallback(
        (confirmarProps: RedefinirSenhaProps) =>
            invocarApi({
                url: `/v4/Auth/redefinir-senha`,
                method: 'POST',
                data: confirmarProps,
                enviarTokenUsuario: false
            }),
        [invocarApi],
    );
    return {
        ...outrasPropriedades,
        postRedefinirSenha,
    };
}
